module.exports = __webpack_public_path__ + "static/media/35.dda69ea2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/35.svg
// module id = 405
// module chunks = 14